import ProjectPropertyLookup, {SourceType} from "./project-property-lookup"
import ProjectSession from "../project-session"
import {ViewType} from "../../../gd/const/views/view-type"
import {TasksViewAppSettings} from "../../../gd-modules/tasks-view/core/@types"

export default class ProjectViewAppSettingsLookup extends ProjectPropertyLookup {

    constructor(projectId: ID) {
        super(projectId)
    }

    get(viewId:ID, forceInheritedOnly = false): TasksViewAppSettings | null {
        let res = null

        // 1. check if project has property and retrieve views
        res = this.getProjectViewsAppSettings(this.project, viewId)
        if (!!res) {
            this.sourceType = SourceType.CUSTOM
        }

        // 2. if views not found yet check parents
        const allParents = this.findAllParents()
        if ((!res || forceInheritedOnly) && allParents.length > 0) {
            _.some(allParents, project=>{
                res = this.getProjectViewsAppSettings(project, viewId)

                // if result found then inherited from current project
                if (!!res) {
                    this.sourceType = SourceType.INHERITED
                    this.sourceProjectId = project.id
                    return true // break iteration loop (_.some)
                }
            })

            /*// if no app settings found in any parent then take last (root) parent as inherit source
            if (!res) {
                res = {}
                this.sourceType = SourceType.INHERITED
                this.sourceProjectId = allParents[allParents.length - 1].id
            }*/
        }

        // 3. if app settings still not found return default app settings
        if (!res) {
            this.sourceType = SourceType.GENERIC
        }

        return res
    }

    getProjectViewsAppSettings(project: ProjectSession, viewId: ID) {
        if (project.settings) {
            return project.settings.viewsAppSettings.getConfig(viewId)
        }

        return null
    }

    getByType(viewType: ViewType, forceInheritedOnly = false): TasksViewAppSettings | null {
        let res = null

        // 1. check if project has property and retrieve views
        res = this.getProjectViewsAppSettings_ByType(this.project, viewType)
        if (!!res) {
            this.sourceType = SourceType.CUSTOM
        }

        // 2. if views not found yet check parents
        const allParents = this.findAllParents()
        if ((!res || forceInheritedOnly) && allParents.length > 0) {
            _.some(allParents, project=>{
                res = this.getProjectViewsAppSettings_ByType(project, viewType)

                // if result found then inherited from current project
                if (!!res) {
                    this.sourceType = SourceType.INHERITED
                    this.sourceProjectId = project.id
                    return true // break iteration loop (_.some)
                }
            })
        }

        // 3. if app settings still not found return default app settings
        if (!res) {
            this.sourceType = SourceType.GENERIC
        }

        return res
    }

    getProjectViewsAppSettings_ByType(project: ProjectSession, viewType: ViewType) {
        if (project.settings) {
            return project.settings.viewsAppSettings.getConfigByViewType(viewType)
        }

        return null
    }
}